













































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DxAutocomplete } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import projectsRepository from '@/services/projectsRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';
import customersRepository from '@/services/customers/customersRepository';
import { AssignedContact, InvoiceDto, InvoiceStatus, ProjectsClient, ProjectContactsClient, InvoicingClosedLogsClient, InvoicingClosedLog } from '@/data/web-api-client';
import moment from 'moment';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxAutocomplete,
  },
})
export default class InvoiceDetailsCard extends Vue {
  @Prop({ required: true })
  invoice!: InvoiceDto;

  @Prop({ required: true })
  saving!: boolean;

  invoicingClosedLogs: InvoicingClosedLog[] = [];
  minInvoiceDate: Date | null = null;
  maxInvoiceDate: Date | null = null;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  projectsClient: ProjectsClient = new ProjectsClient(undefined, this.$axios);
  projectContactsClient: ProjectContactsClient = new ProjectContactsClient(undefined, this.$axios);
  invoicingClosedLogsClient = new InvoicingClosedLogsClient(undefined, this.$axios);

  constructor() {
    super();
  }

  async mounted() {
    if (this.invoice.status !== InvoiceStatus.Paid) {
      this.invoicingClosedLogs = await this.invoicingClosedLogsClient.get();

      this.setMinAndMaxInvoiceDates();
    }
  }

  private getFirstDayOfThisMonth(): Date {
    return moment().set('date', 1).toDate();
  }

  private getLastDayOfPreviousMonth(): Date {
    const firstDayOfMonth = this.getFirstDayOfThisMonth();
    return moment(firstDayOfMonth).add(-1, 'day').toDate();
  }

  private setMinAndMaxInvoiceDates() {
    this.maxInvoiceDate = moment(this.getFirstDayOfThisMonth()).add(1, 'month').toDate();

    if (this.invoicingClosedLogs.length === 0) {
      this.minInvoiceDate = this.getLastDayOfPreviousMonth();
    } else {
      const lastLogDate = this.invoicingClosedLogs.sort((a, b) => new Date(a.closedDate!).valueOf() - new Date(b.closedDate!).valueOf()).pop();

      if (lastLogDate?.closedDate!.getMonth() != new Date().getMonth()) {
        this.minInvoiceDate = this.getLastDayOfPreviousMonth();
      } else {
        this.minInvoiceDate = this.getFirstDayOfThisMonth();
      }
    }
  }

  get taxrates() {
    return [
      { value: 0, text: '0%' },
      { value: 6, text: '6%' },
      { value: 21, text: '21%' },
    ];
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }
            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get projectTypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    const values = catalog ? catalog.values : [];

    return {
      items: values,
    };
  }

  get internalContactsOptions() {
    const users: any[] = this.$store.getters['employees/items'];
    const values = users ? users.map((x: any) => x.displayName) : [];

    return {
      dataSource: values,
      disabled: this.invoice.status! > 1,
    };
  }

  get contactsOptions() {
    const self = this;
    if (self.invoice.projectId && self.invoice.projectId !== null) {
      return {
        dataSource: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            const clients = await this.projectContactsClient.getContacts(self.invoice.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.sendInvoice);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
          byKey: async (val: any) => {
            const clients = await this.projectContactsClient.getContacts(self.invoice.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.contact != undefined && contact.contact.id == val && contact.sendInvoice);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.invoice ? self.invoice.status! > 1 : true,
      };
    } else {
      return {
        dataSource: new DataSource({
          store: new dxCustomStore({
            load: async (loadOptions) => {
              const result = await customersRepository.get(loadOptions);
              return {
                data: result.data,
              };
            },
            byKey: (val: any) => {
              return val;
            },
          }),
          paginate: true,
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.invoice ? self.invoice.status! > 1 : true,
      };
    }
  }

  get customerContactsOptions() {
    const self = this;
    if (self.invoice.projectId && self.invoice.projectId !== null) {
      return {
        dataSource: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            const customers = await new ProjectsClient(undefined, this.$axios).getProjectsContacts(self.invoice.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.sendInvoice);
            });

            return customers.map((customer: AssignedContact) => customer.contact);
          },
          byKey: async (val: any) => {
            const customers = await new ProjectsClient(undefined, this.$axios).getProjectsContacts(self.invoice.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.contact != undefined && contact.contact.id == val && contact.sendInvoice);
            });

            return customers.map((customer: AssignedContact) => customer.contact);
          },
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.invoice ? self.invoice.status! > 1 : true,
      };
    } else {
      return {
        dataSource: new DataSource({
          store: new dxCustomStore({
            load: async (loadOptions) => {
              const result = await customersRepository.get(loadOptions);
              return {
                data: result.data,
              };
            },
            byKey: (val: any) => {
              return val;
            },
          }),
          paginate: true,
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.invoice ? self.invoice.status! > 1 : true,
      };
    }
  }

  get invoiceStatusses() {
    return [
      { value: InvoiceStatus.Draft, text: 'Klad' },
      { value: InvoiceStatus.Open, text: 'Open' },
      { value: InvoiceStatus.Send, text: 'Verstuurd' },
      { value: InvoiceStatus.Overdue, text: 'Te laat' },
      { value: InvoiceStatus.Paid, text: 'Betaald' },
      { value: InvoiceStatus.FirstReminder, text: 'Eerste herinnering' },
      { value: InvoiceStatus.SecondReminder, text: 'Tweede herinnering' },
    ];
  }

  get invoiceDateEditorOptions() {
    return {
      disabled: this.invoice.status && this.invoice.status > 1,
      width: '100%',
      min: this.minInvoiceDate,
      max: this.maxInvoiceDate,
      dateSerializationFormat: 'yyyy-MM-dd',
    };
  }

  get invoiceCopy() {
    return Object.assign({}, this.invoice);
  }

  // Watch on model itself does not remember the pre-mutated value so we watch a copy instead
  @Watch('invoiceCopy', { deep: true })
  onInvoiceChanged(newValue: any, oldValue: any) {
    if (newValue.status !== oldValue.status && newValue.status !== 6) {
      this.setMinAndMaxInvoiceDates();
    }
  }
}
